<template>
    <div @click="downloadFile">
        {{ filename }} <Icon family="fa" name="fa-cloud-download-alt" />
    </div>
</template>

<script>
const backendApiUrl = process.env.VUE_APP_BACKEND_API_URL;

export default {
    name: "photo-action-result",
    props: {
        action: {
            type: Object,
            required: true,
        },
    },
    computed: {
        filename() {
            return this.action.fileName;
        },
    },
    methods: {
        downloadFile() {
            window.open(
                `${backendApiUrl}api/files/photo/${this.action.photoId}/download`,
                "_blank"
            );
        },
    },
};
</script>